import React from "react";
import style from "./skill.module.css";

const skills = [
  "React.js & Redux",
  "React-native & Redux",
  "Node.js & Express",
  "Test Driven Development",
  "Project management",
  "Figma-Web design",
  "Python & Django",
  "Docker & DockerCompose",
  "Javascript",
  "Git & Github",
  "DevOps",
  "HTML&CSS",
  "firebase",
  "English",
  "French",
  "Kinyarwanda",
];

const Skill = () => {
  const oddSkills = skills.filter((s) => skills.indexOf(s) % 2 === 0);
  const evenSkills = skills.filter((s) => skills.indexOf(s) % 2 !== 0);

  return (
    <div className={style.Component}>
      <div className={style.Left}>
        {oddSkills.map((odd, index) => (
          <p key={index}>{odd}</p>
        ))}
      </div>
      <div className={style.Right}>
        {evenSkills.map((even, index) => (
          <p key={index}>{even}</p>
        ))}
      </div>
    </div>
  );
};

export default Skill;
